import { useState, useEffect } from 'react';

export function useScroll() {
  const [lastScrollTop, setLastScrollTop] = useState<number>(0);
  const [bodyOffset, setBodyOffset] = useState<any>(
    global?.document?.body?.getBoundingClientRect()
  );
  const [scrollY, setScrollY] = useState<number>(bodyOffset?.top);
  const [scrollX, setScrollX] = useState<number>(bodyOffset?.left);
  const [scrollDirection, setScrollDirection] = useState<string>();

  const listener = () => {
    setBodyOffset(global.document.body.getBoundingClientRect());
    setScrollY(-bodyOffset.top);
    setScrollX(bodyOffset.left);
    setScrollDirection(lastScrollTop > -bodyOffset.top ? 'down' : 'up');
    setLastScrollTop(-bodyOffset.top);
  };

  useEffect(() => {
    global?.window?.addEventListener('scroll', listener);
    return () => {
      global?.window?.removeEventListener('scroll', listener);
    };
  });

  return {
    scrollY,
    scrollX,
    scrollDirection,
  };
}

export default useScroll;
